// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"bc186b65","547":"6bafe874","564":"caf0c579","839":"17213e87","929":"933085c6","992":"3518a968"}[chunkId] + ".chunk.js";
};